import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class FileService {

  constructor(private http: HttpClient) { }

  public uploadMediaDocuments(files: any, tag: string): Observable<any> {
    const url = `${environment.apiOrigin}/FileService/api/files/public/documents`;
    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }
    formData.append('tags', tag);

    return this.http.put(url, formData);
  }
}
